import React from 'react';
import {TouchableOpacity, TouchableOpacityProps, Animated} from 'react-native';
export default function AVTouchableOpacity(props: TouchableOpacityProps) {
  return (
    <TouchableOpacity
      activeOpacity={0.75}
      //@ts-ignore
      nativeID={props.accessibilityLabel}
      {...props}
    />
  );
}
